import {PlacementCustomParamName} from '../../campaigns/campaigns.types';

export default function isCustomParamOfDateType(customParamKey: string) {
  return (
    customParamKey === PlacementCustomParamName.StartDateTime ||
    customParamKey === PlacementCustomParamName.EndDateTime
  );
}
